import React from 'react';
import './GrayCard.css';
import _isEmpty from 'lodash/isEmpty';
import _isEqual from 'lodash/isEqual';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Link } from 'react-router-dom';


class GrayCard extends React.Component {
    state = {
    }
    renderTitle() {
        if (this.props.type === "amount") {
            return (
                <div className=""> <span className="" style={{ color: "#fff" }}>{this.props.amount}</span></div>
            )
        } else if (this.props.type === "items") {
            return (
                <div className=""> <span className="" style={{ color: "#fff" }}>{this.props.items} (Items)</span></div>
            )

        }
    }

    renderArrow() {
        if (isNaN(Number(this.props.growthAmount))) {

            return (<div >NA</div>
            );
        }
        let growthAmount = this.props.growthAmount;
        growthAmount = growthAmount > 200 ? 200 : growthAmount;
        growthAmount = growthAmount < -200 ? -200 : growthAmount;
        if (this.props.growth === "positive") {
            return (<div className=" green" style={{ color: "#fff" }}>{Number(growthAmount).toFixed(2)}<Link className="success"> <i className="fas fa-arrow-circle-up"></i></Link></div>

            )
        } else if (this.props.growth === "negative") {
            return (
                <div className=" red" style={{ color: "#fff" }}>{Number(growthAmount).toFixed(2)} <Link className="danger"><i className="fas fa-arrow-circle-down"></i></Link></div>
            )
        }
    }

    formatDate(date) {
        let yyyy = date.substring(0, 4);
        let mm = date.substring(5, 7);
        let dd = date.substring(8);
        return mm+'/'+dd+'/'+yyyy;
    }
    renderDate() {
        if ((this.props.updatedDate != '1970-01-01') && (this.props.updatedDate != null)) {
            return (<div style={{ color: "#fff" }} >{this.formatDate(this.props.updatedDate)}</div>
            );
        }
        else {
            return (<div style={{ color: "#fff" }} >NA</div>
            );
        }
    }

    displayModalForRebate() {
        let propsForModal = {
            title: this.props.title,
            purchaseAmount: this.props.purchaseAmount,
            rebateInfo: this.props.rebateInfo

        }
        this.props.displayModal(propsForModal);
    }

    displayModal() {
        let propsForModal = {
            title: this.props.title,
            amount: this.props.amount,
            items: this.props.items,
            type: this.props.type,
            date: this.props.date,
            updatedDate: this.props.updatedDate,
            growthAmount: this.props.growthAmount,
            growth: this.props.growth

        }
        console.log('i got all info , now going back to bh verified');
        this.props.displayModal(propsForModal);
    }

    // renderDate() {
    //     if (this.props.updatedDate != null) {
    //         return (<div style={{ color: "#fff" }}>{this.props.updatedDate}</div>
    //         );
    //     }
    //     else {
    //         return (<div style={{ color: "#fff" }}>NA</div>
    //         );
    //     }
    // }

    renderRebateCard = () => {
        const mystyle = {
            paddingLeft: "0px !important",
            paddingRight: "2px !important",
        }
        console.log(this.props);
        return (
            //, paddingLeft:'0px !important',paddingRight:'2px !important',display: 'flex', flexDirection: 'row',display:"inline-block"
            <div className="vendorCard" style={{ mystyle }}>
                <OverlayTrigger overlay={(<Tooltip id="callModal"> {this.props.title} from IMARK verified data</Tooltip>)} popperConfig={{ modifiers: { preventOverflow: { boundariesElement: 'viewport' } } }} placement="down">

                    <div className=" grayCards panel panel-card" style={{ backgroundColor: "background: #3498db; color : #fff; position: relative;" }}>
                        <div className="panel-body">
                            <div className="panel-title minHeightTitle1"><span>{this.props.title} </span></div>
                            <div className="">
                                <div >
                                    Purchase Amount : {this.props.purchaseAmount}
                                </div>
                            </div>
                        </div>
                        <div className="panel-footer">
                            <span>Click here for Rebate information</span>
                        </div>
                    </div>
                </OverlayTrigger>
            </div>
        )
    }
    renderSalesCard = () => {

        return (
            <div className="col-sm-12" style={{ display: 'flex', flexDirection: 'row', display: "inline-block" }}>
                {/* <OverlayTrigger overlay={(<Tooltip id="callModal"> {this.props.title} from Imark verified data</Tooltip>)} popperConfig={{ modifiers: { preventOverflow: { boundariesElement: 'viewport' } } }} placement="down"> */}

                <div className=" grayCards panel panel-card" style={{ backgroundColor: "#9b59b6", color: "#fff", position: "relative", opacity: "0.8", }} >
                    <div className="panel-main">
                        {this.renderTitleIfRebateFilteredOrNotSales()}
                        <div className="panel-value">

                            {/* will print $ or items based on type */}
                            {this.renderTitle()}

                        </div>
                    </div>
                    {/* {this.props.updatedDate != null ?
                            <React.Fragment>
                                <hr />
                                <div className="panel-footer">
                                    <div className="updatedOn"><span style={{ marginRight: "5px" }}>Last Updated Date</span></div>
                                    <div className="figures">
                                        {this.renderDate()}
                                    </div>

                                </div>
                            </React.Fragment> : ""
                        } */}
                    <hr />
                    <div className="panel-footer">
                        <div className="updatedOn"><span style={{ marginRight: "5px" }}>YOY</span></div>
                        <div className="figures">
                            {this.renderArrow()}
                        </div>

                    </div>

                </div>
                {/* </OverlayTrigger> */}
            </div>
        )
    }
    renderTitleIfRebateFilteredOrNot() {

        if (this.props.title.substring(2, 0) === "BH" || this.props.title.substring(2, 0) === "Bh") {
            return (
                <div className="panel-title minHeightTitle1" style={{ color: "#00bcd4" }}><span>{this.props.title} </span>
                    <span style={{ position: "absolute", top: "10px", right: "10px", textAlign: "right" }} data-display="imarkDate">Updated On <br />
                        {this.renderDate()}</span></div>
                //  {/* <span style = {{marginLeft: "138px!important"}}><div>{this.props.updatedDate}</div> </span></div> */}
            )
        }

        if (this.props.title == "Vendor Total Sales") {
            return (
                <div className="panel-title minHeightTitle1" style={{ color: "#fff" }}><span>Supplier Total Sales </span>
                    <span style={{ position: "absolute", top: "10px", right: "10px", textAlign: "right" }} data-display="imarkDate">Updated On <br />
                        {this.renderDate()}</span></div>
            )
        }
        if (this.props.title == "Vendor Total Rebate") {
            return (
                <div className="panel-title minHeightTitle1" style={{ color: "#fff" }}><span>Supplier Total Rebate </span>
                    <span style={{ position: "absolute", top: "10px", right: "10px", textAlign: "right" }} data-display="imarkDate">Updated On <br />
                        {this.renderDate()}</span></div>
            )
        }
        return (
            <div className="panel-title minHeightTitle1" style={{ color: "#fff" }} ><span>{this.props.title} </span>
                <span style={{ position: "absolute", top: "10px", right: "10px", textAlign: "right" }} data-display="imarkDate">Updated On <br />
                    {this.renderDate()}</span></div>

        )

    }
    renderTitleIfRebateFilteredOrNotSales() {

        if (this.props.title.substring(2, 0) === "BH" || this.props.title.substring(2, 0) === "Bh") {
            return (
                <div className="panel-title minHeightTitle1" style={{ color: "#00bcd4" }}><span>{this.props.title} </span></div>

            )
        }
        return (
            <div className="panel-title minHeightTitle1" style={{ color: "#fff" }} ><span>{this.props.title} </span> </div>

        )

    }
    render() {
        const { show } = this.props;
        if (this.props.type === "rebateCard") {
            return this.renderRebateCard()
        }
        if (this.props.title === "Sales Opportunity ($)") {
            return this.renderSalesCard()
        }
        if (this.props.title === "IMARK Total Sales") {
            console.log(this.props);
            return (
                <div className="vendorCard" style={{ paddingLeft: '0px !important', paddingRight: '2px !important', display: 'flex', flexDirection: 'row', display: "inline-block", color: "#fff" }}>
                    {/* <OverlayTrigger overlay={(<Tooltip id="callModal"> {this.props.title} from Imark verified data</Tooltip>)} popperConfig={{ modifiers: { preventOverflow: { boundariesElement: 'viewport' } } }} placement="down"> */}

                    <div className=" grayCards panel panel-card" style={{ backgroundColor: "#3498db", color: "#fff", position: "relative", opacity: "0.8", }} >
                        <div className="panel-main">
                            {this.renderTitleIfRebateFilteredOrNot()}

                            <div className="panel-value">

                                {/* will print $ or items based on type */}
                                {this.renderTitle()}

                            </div>
                        </div>
                        {/* {this.props.updatedDate != null ?
                                // <React.Fragment>
                                //     <hr />
                                    <div className="panel-footer">
                                        <div className="updatedOn"><span style={{ marginRight: "5px" }}>Updated Date</span></div>
                                        <div className="figures">
                                            {this.renderDate()}
                                        </div>

                                    </div>
                                // </React.Fragment> 
                                : ""
                            } */}
                        <hr />
                        <div className="panel-footer">
                            <div className="updatedOn"><span style={{ marginRight: "5px" }}>YOY</span></div>
                            <div className="figures">
                                {this.renderArrow()}
                            </div>

                        </div>

                    </div>
                    {/* </OverlayTrigger> */}
                </div>
            )
        }

        if (this.props.title === "Vendor Total Sales") {
            return (
                <div className="vendorCard" style={{ paddingLeft: '0px !important', paddingRight: '2px !important', display: 'flex', flexDirection: 'row', display: "inline-block", color: "#fff" }}>
                    {/* <OverlayTrigger overlay={(<Tooltip id="callModal"> Base Rebate + FBI Rebate</Tooltip>)} popperConfig={{ modifiers: { preventOverflow: { boundariesElement: 'viewport' } } }} placement="down"> */}

                    <div className=" grayCards panel panel-card" style={{ backgroundColor: "#78909C", color: "#fff", position: "relative", opacity: "0.8", }} >
                        <div className="panel-main">
                            {this.renderTitleIfRebateFilteredOrNot()}
                            <div className="panel-value">

                                {/* will print $ or items based on type */}
                                {this.renderTitle()}

                            </div>
                        </div>
                        {/* {this.props.updatedDate != null ?
                                <React.Fragment>
                                    <hr />
                                    <div className="panel-footer">
                                        <div className="updatedOn"><span style={{ marginRight: "5px" }}>Last Updated Date</span></div>
                                        <div className="figures">
                                            {this.renderDate()}
                                        </div>

                                    </div>
                                </React.Fragment> : ""
                            } */}
                        <hr />
                        <div className="panel-footer">
                            <div className="updatedOn"><span style={{ marginRight: "5px" }}>YOY</span></div>
                            <div className="figures">
                                {this.renderArrow()}
                            </div>

                        </div>

                    </div>
                    {/* </OverlayTrigger> */}
                </div>
            )
        }

        if (this.props.title === "IMARK Total Rebate") {
            return (
                <div className="vendorCard" style={{ paddingLeft: '0px !important', paddingRight: '2px !important', display: 'flex', flexDirection: 'row', display: "inline-block", color: "#fff" }}>
                    <OverlayTrigger overlay={(<Tooltip id="callModal"> Base Rebate + FBI Rebate</Tooltip>)} popperConfig={{ modifiers: { preventOverflow: { boundariesElement: 'viewport' } } }} placement="down">

                        <div className=" grayCards panel panel-card" style={{ backgroundColor: "#e67e22", color: "#fff", position: "relative", opacity: "0.8", }} >
                            <div className="panel-main">
                                {this.renderTitleIfRebateFilteredOrNot()}
                                <div className="panel-value">

                                    {/* will print $ or items based on type */}
                                    {this.renderTitle()}

                                </div>
                            </div>
                            {/* {this.props.updatedDate != null ?
                                <React.Fragment>
                                    <hr />
                                    <div className="panel-footer">
                                        <div className="updatedOn"><span style={{ marginRight: "5px" }}>Last Updated Date</span></div>
                                        <div className="figures">
                                            {this.renderDate()}
                                        </div>

                                    </div>
                                </React.Fragment> : ""
                            } */}
                            <hr />
                            <div className="panel-footer">
                                <div className="updatedOn"><span style={{ marginRight: "5px" }}>YOY</span></div>
                                <div className="figures">
                                    {this.renderArrow()}
                                </div>

                            </div>

                        </div>
                    </OverlayTrigger>
                </div>
            )
        }
        if (this.props.title === "Vendor Total Rebate") {
            return (
                <div className="vendorCard" style={{ paddingLeft: '0px !important', paddingRight: '2px !important', display: 'flex', flexDirection: 'row', display: "inline-block" }}>
                    <OverlayTrigger overlay={(<Tooltip id="callModal"> Base Rebate + FBI Rebate</Tooltip>)} popperConfig={{ modifiers: { preventOverflow: { boundariesElement: 'viewport' } } }} placement="down">

                        <div className=" grayCards panel panel-card" style={{ backgroundColor: "#FFA726", color: "#fff", position: "relative", opacity: "0.8", }} >
                            <div className="panel-main">
                                {this.renderTitleIfRebateFilteredOrNot()}
                                <div className="panel-value">

                                    {/* will print $ or items based on type */}
                                    {this.renderTitle()}

                                </div>
                            </div>
                            {/* {this.props.updatedDate != null ?
                                <React.Fragment>
                                    <hr />
                                    <div className="panel-footer">
                                        <div className="updatedOn"><span style={{ marginRight: "5px" }}>Last Updated Date</span></div>
                                        <div className="figures">
                                            {this.renderDate()}
                                        </div>

                                    </div>
                                </React.Fragment> : ""
                            } */}
                            <hr />
                            <div className="panel-footer">
                                <div className="updatedOn"><span style={{ marginRight: "5px" }}>YOY</span></div>
                                <div className="figures">
                                    {this.renderArrow()}
                                </div>

                            </div>

                        </div>
                    </OverlayTrigger>
                </div>
            )
        }
    }

}
export default GrayCard;
